import { common } from './common';
import { shell } from './shell';
import { auth } from './auth';
import { activity } from './activity';
import { alarms } from './alarms';
import { analytics } from './analytics';
import { admin } from './admin';
import { guards } from './guards';
import { patrols } from './patrols';
import { profile } from './profile';
import { reports } from './reports';
import { schedule } from './schedule';
import { sites } from './sites';
import { services } from './services';
import { clientPortal } from './clientPortal';
import { command } from './command';
import { payroll } from './payroll';
import { billing } from './billing';
import { profitability } from './profitability';

/**
 * French dictionary. Keys are the exact English source strings used in the
 * code (see src/i18n/index.tsx). Split by feature area to stay reviewable.
 */
export const fr: Record<string, string> = {
  ...common,
  ...shell,
  ...auth,
  ...activity,
  ...alarms,
  ...analytics,
  ...admin,
  ...guards,
  ...patrols,
  ...profile,
  ...reports,
  ...schedule,
  ...sites,
  ...services,
  ...clientPortal,
  ...command,
  ...payroll,
  ...billing,
  ...profitability,
};
